var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab

function showTab(n) {
	// This function will display the specified tab of the form...
	var x = document.getElementsByClassName("tab");
	x[n].style.display = "block";
	//... and fix the Previous/Next buttons:
	if (n == 0) {
		document.getElementById("prevBtn").style.display = "none";
	} else {
		document.getElementById("prevBtn").style.display = "inline";
	}
	if (n == (x.length - 1)) {
		document.getElementById("nextBtn").innerHTML = "Submit";
      	$("#nextBtn").css("display", "none");
      	$("#finalSubmit").css("display", "block");
	} else {
		document.getElementById("nextBtn").innerHTML = "Next";
      	
	}
	//... and run a function that will display the correct step indicator:
	fixStepIndicator(n)
}

function nextPrev(n) {
	// This function will figure out which tab to display
	var x = document.getElementsByClassName("tab");
	// Exit the function if any field in the current tab is invalid:
	if (n == 1 && !validateForm()) return false;

	// Hide the current tab:
	x[currentTab].style.display = "none";
	// Increase or decrease the current tab by 1:
	currentTab = currentTab + n;
	// if you have reached the end of the form...
	if (currentTab >= x.length) {
		// ... the form gets submitted:
		document.getElementById("quiz_form").submit();
		return false;
	}
	// Otherwise, display the correct tab:
	showTab(currentTab);
}

function validateForm() {
	// This function deals with validation of the form fields
	var x, y, i, valid = true;
	x = document.getElementsByClassName("tab");
	y = x[currentTab].getElementsByTagName("input");
	// A loop that checks every input field in the current tab:
	for (i = 0; i < y.length; i++) {
		// If a field is empty...
		if (y[i].value == "") {
	  		// add an "invalid" class to the field:
	  		y[i].className += " invalid";
	  		// and set the current valid status to false
	  		valid = false;
		}
	}
	// If the valid status is true, mark the step as finished and valid:
	if (valid) {
		document.getElementsByClassName("step")[currentTab].className += " done";
	}
	return valid; // return the valid status
}

function fixStepIndicator(n) {
  	/*// This function removes the "active" class of all steps...
  	var i, x = document.getElementsByClassName("step");
  	for (i = 0; i < x.length; i++) {
    	x[i].className = x[i].className.replace(" active", "");
  	}
  	//... and adds the "active" class on the current step:
  	x[n].className += " active";*/

  	// This function removes the "active" class of all steps...
  	var i, x = document.getElementsByClassName("step");
  	for (i = 0; i < x.length; i++) {
    	x[i].className = x[i].className.replace(" active", "");
  	}
  	//... and adds the "active" class on the current step:
  	x[n].className += " active";
}

jQuery(document).ready(function($){
  jQuery(document).on('click', '.addall', function(){

    jQuery(".recommended-product").each(function() {                                      
      if(jQuery(this).css('display') == "inline-block") {
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    quantity: 1,
                    id: jQuery("form input", this).val()
                },
              async: false
            });
      }
    });
    
    var win = window.open();
    win.location = '/cart';
    win.opener = null;
    win.blur();
    window.focus();
  });
});


jQuery(document).ready(function($){
	$(document).on('click', '.checkBoxClick', function(){
		$(this).parents('ul').find('.checkBoxClick').removeClass('bold-status');
		$(this).parents('ul').find('.iradio').removeClass('checked');
		$(this).addClass('bold-status');
		$(this).find('.iradio').addClass('checked');
	});
  
  $(document).ready(function(){
        $(document).on('click','#finalSubmit',function() {
            var radioOne = $("input[name='your_skin_type']:checked").val();
          	var radioTwo = $("input[name='breakouts']:checked").val();
          	var radioThree = $("input[name='blackheads']:checked").val();
          	var radiofour = $("input[name='sensitivity']:checked").val();
          	var radiofive = $("input[name='skin_maturity']:checked").val();
          	var radioSix = $("input[name='firmness']:checked").val();
          	var radioSeven = $("input[name='your_complexion']:checked").val();
            if(radioOne || radioTwo || radioThree || radiofour || radiofive || radioSix || radioSeven){
//              alert("1- " + radioOne + " 2- " + radioTwo + " 3- " + radioThree + " 4- " + radiofour + " 5- " + radiofive + " 6- " + radioSix + " 7- " +  radioSeven);
              	$(".show-beautyResult").css("display", "block");
              	$("#quiz_form").css("display", "none");
              $(".right-part").css("display", "none");
              $(".left-part").css("width", "100%");
              $('.header1').hide();
              $('.header2').show();
              if(radioOne == 1 && radioSeven !=2 && radioSeven !=3){
                $(".questionFirst-recommended-product-one").css("display", "inline-block");
              }else if(radioOne == 2 && radioSeven !=1){
                $(".questionFirst-recommended-product-two").css("display", "inline-block");
              }
              else if(radioOne == 3 && radioSeven !=1){
                $(".questionFirst-recommended-product-three").css("display", "inline-block");
              }
              else if(radioOne == 4 && radioSeven !=1 && radioSeven !=2){
                $(".questionFirst-recommended-product-four").css("display", "inline-block");
              }
              else if(radioOne == 5 && radioTwo!= 5){
                $(".questionFirst-recommended-product-five").css("display", "inline-block");
              }else{
                $(".qf_box").css("display", "none");
              }
              
              
              if(radioTwo == 1){
                $(".questionSecond-recommended-product-one").css("display", "inline-block");
              }else if(radioTwo == 2){
                $(".questionSecond-recommended-product-two").css("display", "inline-block");
              }else if(radioTwo == 3){
                $(".questionSecond-recommended-product-three").css("display", "inline-block");
              }else if(radioTwo == 4){
                $(".questionSecond-recommended-product-four").css("display", "inline-block");
              }else if(radioTwo == 5){
                $(".questionSecond-recommended-product-five").css("display", "inline-block");
              }else{
                $(".qs_box").css("display", "none");
              }
              
              
              if(radioThree ==1 && radiofour !=4){
                $(".questionThird-recommended-product-one").css("display", "inline-block");
              }else if(radioThree ==2 && radiofour !=4){
                $(".questionThird-recommended-product-two").css("display", "inline-block");
              }else if(radioThree ==3 && radiofour !=4){
                $(".questionThird-recommended-product-three").css("display", "inline-block");
              }else{
                $(".qt_box").css("display", "none");
              }
              
              
              if(radiofour == 1){
                $(".questionForth-recommended-product-one").css("display", "inline-block");
              }else if(radiofour == 2){
                $(".questionForth-recommended-product-two").css("display", "inline-block");
              }else if(radiofour == 3){
                $(".questionForth-recommended-product-three").css("display", "inline-block");
              }else if(radiofour == 4){
                $(".questionForth-recommended-product-four").css("display", "inline-block");
              }else{
                $(".qft_box").css("display", "none");
              }
              
              
              if(radiofive == 1){
                $(".questionFifth-recommended-product-one").css("display", "inline-block");
              }else if(radiofive == 2){
                $(".questionFifth-recommended-product-two").css("display", "inline-block");
              }else if(radiofive == 3){
                $(".questionFifth-recommended-product-three").css("display", "inline-block");
              }else if(radiofive == 4){
                $(".questionFifth-recommended-product-four").css("display", "inline-block");
              }else{
                $(".qfv_box").css("display", "none");
              }
              
              
              if(radioSix == 2){
                $(".questionSixth-recommended-product-two").css("display", "inline-block");
              }else if(radioSix == 3){
                $(".questionSixth-recommended-product-three").css("display", "inline-block");
              }else{
                $(".qsx_box").css("display", "none");
              }
              
              
              if(radioSeven == 1 && radioOne !=1){
                $(".questionSeventh-recommended-product-one").css("display", "inline-block");
              }else if(radioSeven == 2 && (radioOne !=2 && radioOne !=3)){
                $(".questionSeventh-recommended-product-two").css("display", "inline-block");
              }else if(radioSeven == 3 && (radioOne !=2 && radioOne !=3)){
                $(".questionSeventh-recommended-product-three").css("display", "inline-block");
              }else if(radioSeven == 4 && (radioOne !=2 && radioOne !=3)){
                $(".questionSeventh-recommended-product-four").css("display", "inline-block");
              }else if(radioSeven == 5 && (radioOne !=2 && radioOne !=3)){
                $(".questionSeventh-recommended-product-five").css("display", "inline-block");
              }else{
                $(".qsv_box").css("display", "none");
              }
              
            }
        });
    });
});

